type RECORD_TYPE = {
  product: {
    id: number
    product_id: number
    blended: boolean
    components: Array<any>
  }
  isComplete: boolean
  quantity: {
    value: string
    error: string
  }
  terminal: {
    id: number
    name?: string
  }
  supplier: {
    id: number
  }
  loading_number: {
    id: number
  }
  tank_id?: number
  components: any
  pickupProductId?: string
  deliveryProductId?: string
  price: number
  cost_basis?: number | null
  blended?: boolean
  preferences: {
    default_terminal: number
    default_supplier: number
    default_loading_number: number
  }[]
}

type INGREDIENT = {
  product: number
  quantity: number
  terminal: number
  terminal_label?: string
  supplier: number
  loading_number: number
  price: number
  pickupProductId?: string
  newPrefs: NEW_PREF[]
}

type NEW_PREF = {
  terminal: { id: number }
  supplier: { id: number }
  loading_number: { id: number }
}

type PRICE_TYPE = {
  value?: string
  price_with_fees: number | string
  freight_rate: number
  source: string
  cost_basis?: number | null
}

export const generateDeliveryProduct = (
  data: RECORD_TYPE,
  price: PRICE_TYPE,
  prefs: NEW_PREF[]
) => {
  const terminal = data?.terminal?.id
  const loading_number_id = data?.loading_number?.id
  const supplier = loading_number_id ? data?.supplier?.id : undefined
  let components = [] as any
  const ingredients = Object.values(data?.components ?? {}) as INGREDIENT[]

  if (ingredients?.length) {
    // CREATE_LOAD expects components as map. This is a good enough place to map
    components = ingredients.map((ing: INGREDIENT) => {
      const ingPrefs = (ing?.newPrefs ?? []).filter((p) => p?.terminal)
      const ingSupplier = ing.loading_number ? ing.supplier : undefined
      return {
        pickupProductId: ing.pickupProductId,
        product: ing.product,
        gross_quantity: ing.quantity,
        terminal: ing.terminal,
        terminal_label: ing.terminal_label,
        supplier: ingSupplier,
        loading_number_id: ing.loading_number,
        preferred_source: {
          id: ingSupplier,
          value: ingSupplier,
          supplier: ingSupplier,
          terminal: ing.terminal,
          loading_number_id: ing.loading_number,
        },
        additionalPreferences: ingPrefs,
      }
    })
  }

  prefs = (prefs ?? []).filter((p) => p?.terminal?.id)

  const body = {
    gross_quantity: !data?.quantity?.value
      ? 0
      : parseFloat(data?.quantity?.value),
    product: data?.product?.product_id ?? data?.product?.id,
    components,
    blended: data?.product?.blended,
    product_id: data?.product?.product_id ?? data?.product?.id,
    tank_id: data?.tank_id,
    pickupProductId: data?.pickupProductId,
    deliveryProductId: data?.deliveryProductId,
    terminal,
    terminal_label: data?.terminal?.name,
    supplier,
    isComplete: data?.isComplete,
    loading_number_id,
    preferred_source: {
      id: supplier,
      value: supplier,
      terminal,
      supplier,
      loading_number_id,
    },
    additionalPreferences: prefs,
    cost_basis: price?.cost_basis ?? null,
  } as any

  if (price?.value && !isNaN(parseFloat(`${price?.value}`)))
    body.price = parseFloat(`${price?.value}`).toFixed(4)

  if (price?.price_with_fees && !isNaN(parseFloat(`${price?.price_with_fees}`)))
    body.price = parseFloat(
      `${price?.value ?? price?.price_with_fees}`
    ).toFixed(4)

  return body
}
